export class ToastData {
  title = ''
  subTitle = ''
  date?: any
  type: ToastType = 'info'
  time?: number
  panelClass?: string
  onDismiss?: () => void
  actionLabel?: string
  onAction?: () => void
}

export type ToastType = 'warning' | 'error' | 'info' | 'success'
